import u from '@/utils'
import axios from 'axios'

const state = {
  honeyFormsLoading: false,
  honeyForms: [],
  myHoneyForms: []
}

const getters = {
  getHoneyForms() {
    return state.honeyForms
  }
}

const mutations = {
  honeyFormsLoading(state, isLoading) {
    state.honeyFormsLoading = isLoading
  },

  setHoneyForms(state, honeyForms) {
    state.honeyForms = honeyForms
  },
  setMyHoneyForms(state, myHoneyForms) {
    state.myHoneyForms = myHoneyForms
  },

  updateHoneyForm(state, honeyForm) {
    let index = state.honeyForms.findIndex(
      item => item.hexId === honeyForm.hexId
    )
    state.honeyForms.splice(index, 1, honeyForm)
  }
}

let actions = {
  async fetchHoneyForms({ commit }) {
    commit('honeyFormsLoading', true)
    let response = await axios.get('/api/v1/honeyForms')
    let honeyForms = [...response.data._embedded.honeyForms]
    honeyForms = honeyForms.map(honeyForm => u.processResp(honeyForm))
    commit('setHoneyForms', honeyForms)
    commit('honeyFormsLoading', false)
    return honeyForms
  },

  async fetchMyHoneyForms({ commit }) {
    let response = await axios.get('/api/v1/honeyForms/me')
    let honeyForms = [...response.data._embedded.honeyForms]
    honeyForms = honeyForms.map(honeyForm => u.processResp(honeyForm))
    commit('setMyHoneyForms', honeyForms)
    return honeyForms
  },

  async fetchHoneyForm({ commit }, hexId) {
    let response = await axios.get(`/api/v1/honeyForms/${hexId}`)
    response.data = u.processResp(response.data)
    commit('updateHoneyForm', response.data)
    return response.data
  },

  async updateHoneyForm({ commit }, { body, hexId }) {
    let response = await axios.patch(`/api/v1/honeyForms/${hexId}`, body)
    response.data = u.processResp(response.data)
    commit('updateHoneyForm', response.data)
    return response.data
  },

  async fetchEmailTemplateForForm(context, hexId) {
    let response = await axios.get(`/api/v1/honeyForms/${hexId}/emailTemplate`)
    return response.data
  },

  async deleteHoneyForm(context, hexId) {
    await axios.delete(`/api/v1/honeyForms/${hexId}`)
  },

  async saveHoneyForm(context, honeyFormBody) {
    let response = await axios.post('/api/v1/honeyForms', honeyFormBody)
    return response.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
